/* eslint-disable @angular-eslint/directive-selector */

import { Directive, inject } from '@angular/core';
import { DatetimeboxComponent } from '../components/basic/datetimebox/datetimebox.component';
import { DatetimeType } from '../models/datetime-type.model';

@Directive({ selector: 'app-datetimebox[datetime]' })
export class DatetimeboxDatetimeDirective {
  private component = inject(DatetimeboxComponent);

  constructor() {
    this.component.type.set(DatetimeType.DateTime);
  }
}
